"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchCommand = void 0;
class SearchCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { search_string } = this.input;
        const { gtag: googleAnalyst } = config;
        googleAnalyst('event', 'search', {
            search_term: search_string ?? 'no-search-string'
        });
        return Promise.resolve();
    }
}
exports.SearchCommand = SearchCommand;
